// extracted by mini-css-extract-plugin
export var dividerLine = "_4x-0";
export var errorBackground = "_4x-1";